import axios from "axios";
import { ProducerPaginated } from "../models";

export const getPaginatedProducers = (pageNumber: number, pageSize: number): any => {
    return axios.get<ProducerPaginated>("producers/pagin?pageNumber=" + (pageNumber + 1) + "&pageSize=" + pageSize);
}